export default __webpack_public_path__ + "static/media/new toki.51a3d28f.png";